export function getPathWithoutLocalePrefix(path: string, locale: string): string {
  const prefix = `/${locale}`
  if(path === prefix) {
    return '/'
  }
  if(path.startsWith(`${prefix}/`)) {
    return path.slice(prefix.length)
  }
  return path
}
